import React from 'react';
import {
  Container,
  RoomNumber,
  RoomDetails,
  RoomInfoContainer,
  AccentColorText,
  LocationMarker,
  RoomTitleContainer,
} from './styles';
import { translate as t } from 'utils/i18n';
/**
 * TV-Optimized Room Info Badge
 * Displays room number and type information
 */
export default function RoomInfoBadge({ roomNumber, roomType, floor }) {
  if (!roomNumber) return null;

  return (
    <Container>
      <RoomInfoContainer>
        <RoomTitleContainer>
          <LocationMarker className='fa fa-map-marker' aria-hidden='true'></LocationMarker>
          <RoomNumber>
            {t('Room.name')} {roomNumber}
          </RoomNumber>
        </RoomTitleContainer>

        {(roomType || floor) && (
          <RoomDetails>
            {roomType && <span>{roomType}</span>}
            {roomType && floor && <AccentColorText> • </AccentColorText>}
            {floor && <span>{floor}</span>}
          </RoomDetails>
        )}
      </RoomInfoContainer>
    </Container>
  );
}
